import type { DialogueLine } from '../types.js';

/** Recent first lines. An opening stays banned until `capacity` newer ones replace it. */
export interface OpeningHistory {
  pair: Map<string, DialogueLine[]>;
  world: DialogueLine[];
  capacity: number;
}

export function createOpeningHistory(capacity = 8): OpeningHistory {
  return { pair: new Map(), world: [], capacity };
}

function pairKey(a: string, b: string): string {
  return a < b ? `${a}|${b}` : `${b}|${a}`;
}

function pushRing(list: DialogueLine[], line: DialogueLine, capacity: number): DialogueLine[] {
  const next = [...list, line];
  return next.length > capacity ? next.slice(next.length - capacity) : next;
}

export function recordOpening(history: OpeningHistory, aId: string, bId: string, line: DialogueLine): void {
  const key = pairKey(aId, bId);
  history.pair.set(key, pushRing(history.pair.get(key) ?? [], line, history.capacity));
  history.world = pushRing(history.world, line, history.capacity);
}

/** Pair bans keep the speaker. World bans are the text only, so other pairs cannot reuse it. */
export function openingBans(history: OpeningHistory, aId: string, bId: string): string[] {
  const pair = history.pair.get(pairKey(aId, bId)) ?? [];
  const lines = [
    ...pair.map((l) => `${l.speaker}: ${l.text}`),
    ...history.world.map((l) => l.text),
  ];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const line of lines) {
    const key = line.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(line);
  }
  return out;
}
